<template>
  <div>
    <div v-if="operation_attribute_id == quality_attribute.id">
      <p>{{ operation_value }}</p>
    </div>
    <template v-else>
      <!-- <div class="flex rounded-md shadow-sm">
        <input type="text" v-model.number="value" class="input-text-append" />
        <span class="input-append"> % </span>
      </div> -->
      <input
        v-if="crop_attribute_type_is_continous"
        type="text"
        v-model.number="value"
        class="input-text min-w-[3rem]"
      />
      <input
        v-else-if="crop_attribute_type_is_boolean"
        type="checkbox"
        v-model="value"
        class="input-checkbox min-w-[3rem]"
      />
    </template>
  </div>
</template>
<script>
import GeneralQuality from "@/components/views/layout/quality_control/mixins/quality_general.js";
import QualityAttributeMixin from "@/components/views/mixins/models/quality_attribute.js";

export default {
  props: {
    modelValue: {
      required: true,
    },
    quality_attribute: {
      type: Object,
      required: true,
    },
    quality_group: {
      type: Object,
      required: true,
    },
    general_values: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mixins: [GeneralQuality, QualityAttributeMixin],
  data() {
    return {
      value: this.modelValue,
    };
  },
  computed: {
    // group_general_values: function () {
    //   if (!this.general_values) return {};
    //   return this.general_values[this.quality_group.id];
    // },
    operation_attribute_id: function () {
      if (this.quality_group?.use_operation)
        return this.quality_group?.quality_attribute_id;
      return null;
    },
    operation_value: function () {
      return this.calculateGeneralOperationByGroup(
        this.quality_group,
        this.general_values
      );
    },
    operator_id: function () {
      return this.quality_group?.operator_id;
    },
    is_operation_sum: function () {
      return this.operator_id == 1;
    },
    is_operation_average: function () {
      return this.operator_id == 2;
    },
    crop_attribute_type_is_boolean: function () {
      return this.qualityAttributeIsBoolean(this.quality_attribute);
    },
    crop_attribute_type_is_continous: function () {
      return this.qualityAttributeIsContinous(this.quality_attribute);
    },
  },
  methods: {},
  watch: {
    value: function (new_value) {
      this.$emit("update:modelValue", new_value);
    },
  },
};
</script>
